module.exports = __webpack_public_path__ + "fonts/SF-Pro-Display-Light.fdd4f443.ttf";